import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardWithForcedLogin } from "src/app/core/auth/auth-guard-with-forced-login.service";
import { HSPAPermission } from "src/app/shared/models/hspa-permission.enum";
import { AddFacilityComponent } from "./add-facility/add-facility.component";
import { FacilitiesComponent } from "./facilities.component";

const routes: Routes = [
    {
      path: '',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.HospitalFacilitiesAccess},
      component: FacilitiesComponent
    },
    {
      path: 'add-facility',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.OnboardingHospitalFacilities},
      component: AddFacilityComponent
    },
    {
      path: 'edit-facility/:id',
      canActivate: [AuthGuardWithForcedLogin],
      data: { expectedPermissions: HSPAPermission.OnboardingHospitalFacilities},
      component: AddFacilityComponent
    }
    ];
    
    @NgModule({
      imports: [RouterModule.forChild(routes)],
      exports: [RouterModule]
    })
    export class FacilitiesRoutingModule { }